export const speechTimerConfig = {
    availableOptions: [
        { label: 'com.file.speech-timer-config.1minute', value: 60 },
        { label: 'com.file.speech-timer-config.2minute', value: 120 },
        { label: 'com.file.speech-timer-config.3minute', value: 180 },
        { label: 'com.file.speech-timer-config.5minute', value: 300 },
        { label: 'com.file.speech-timer-config.10minute', value: 600 },
        { label: 'com.file.speech-timer-config.15minute', value: 900 },
        { label: 'com.file.speech-timer-config.20minute', value: 1200 },
        { label: 'com.file.speech-timer-config.30minute', value: 1800 }
    ]
}